/**
 * ADVANCED FORCE LAZY LOAD FOR ELLA 7+
 * - Keeps first slide high priority
 * - Downgrades other slides to smaller size
 * - Prevents 3840px flood
 * - Swiper safe
 */

(function () {
  "use strict";

  const SMALL_WIDTH = 900; // initial load width

  function optimizeImage(img, isActive) {
    if (img.dataset.optimized === "true") return;

    const originalSrc = img.getAttribute("src");

    if (!originalSrc) return;

    if (!isActive) {
      // Replace 3840 with smaller width
      const smallerSrc = originalSrc.replace(/width=\d+/g, "width=" + SMALL_WIDTH);

      img.setAttribute("src", smallerSrc);

      img.loading = "lazy";
      img.setAttribute("fetchpriority", "low");
    } else {
      img.loading = "eager";
      img.setAttribute("fetchpriority", "high");
    }

    img.dataset.optimized = "true";
  }

  function processSlides() {
    const slides = document.querySelectorAll(".swiper-slide");

    slides.forEach((slide) => {
      const img = slide.querySelector("img");
      if (!img) return;

      const isActive = slide.classList.contains("swiper-slide-active");

      optimizeImage(img, isActive);
    });
  }

  function handleSlideChange() {
    document.addEventListener("transitionend", function (e) {
      if (e.target.closest(".swiper")) {
        processSlides();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    processSlides();
    handleSlideChange();
  });

  document.addEventListener("shopify:section:load", function () {
    processSlides();
  });

})();